export const RISK_RULE_ENDPOINTS = {
  add: '/tax/v1/risk/rule/add',
  enable: '/tax/v1/risk/rule/enable',
  disable: '/tax/v1/risk/rule/disable',
};

const ENABLED_STATUS = new Set(['009', 'enable', 'enabled', '启用']);
const DISABLED_STATUS = new Set(['003', 'disable', 'disabled', '禁用']);

export function isEnabled(row = {}) {
  return ENABLED_STATUS.has(String(row.enableStatus).toLowerCase());
}

export function clickVisible({ row = {}, val = {} }) {
  if (val.code === 'enable') return !isEnabled(row);
  if (val.code === 'disable') return isEnabled(row);
  return true;
}

export function operateRiskRule({
  code, row, selection = [], request, onSuccess, onEmpty,
}) {
  const ids = row && row.id !== undefined && row.id !== null
    ? [row.id]
    : selection.filter((id) => id !== undefined && id !== null);

  if (!ids.length) {
    if (onEmpty) onEmpty();
    return Promise.resolve({ success: false, skipped: true });
  }

  const endpoint = RISK_RULE_ENDPOINTS[code];
  if (!endpoint) return Promise.reject(new Error(`Unsupported risk rule operation: ${code}`));

  return request.post(endpoint, ids).then((res) => {
    if (res.success && onSuccess) onSuccess(res);
    return res;
  });
}
